module.exports = __webpack_public_path__ + "img/mobile_team_top_img.a2dba159.jpg";